export default __webpack_public_path__ + "static/media/lake-eola-park.392529d1.jpg";